import axios from "axios";
import toast from "react-hot-toast";

const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

Api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

let isLoggingOut = false;

const handleAccountDeleted = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  toast.error("Your account has been deleted by Admin");
  setTimeout(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  }, 2000);
};

Api.interceptors.response.use(
  function (response) {
    if (
      response.data &&
      (response.data.statusCode === 400 || response.data.statusCode === 401 || response.data.statusCode === 403) &&
      response.data.message === "Your account has been deleted by Admin"
    ) {
      handleAccountDeleted();
    }
    return response;
  },
  function (error) {
    if (
      error.response &&
      error.response.data &&
      (error.response.data.statusCode === 400 || error.response.data.statusCode === 401 || error.response.data.statusCode === 403) &&
      error.response.data.message === "Your account has been deleted by Admin"
    ) {
      handleAccountDeleted();
    }
    return Promise.reject(error);
  },
);

export default Api;
